import { render } from "./Contact.vue?vue&type=template&id=2af82214"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=2af82214&lang=scss"

import exportComponent from "/home/los4/mnt/OutHouse/los/Documents/htdocs/LosPrograms/Life/regLosers/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__